import React from 'react';
import PropTypes from 'prop-types';

const ShowHide = ({ prompt, bulleted, content }) => (
  <div className="showhide">
    <div className="expand">
      <h4>{prompt}</h4>
    </div>
    {bulleted ? (
      <ul>
        {content.map((item, index) => (
          // eslint-disable-next-line
          <li key={index}>{item}</li>
        ))}
      </ul>
    ) : (
      <p>{content}</p>
    )}
  </div>
);

ShowHide.propTypes = {
  prompt: PropTypes.string.isRequired,
  bulleted: PropTypes.bool.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
};

export default ShowHide;
